// Turns a date into a short label for a given kid — "Day C", "Village
// History", or "No school" — using each kid's own calculator underneath.
// Shared by TodayTomorrowSection.js (Home dashboard) and KidDashboard.js
// (each kid's own dashboard badge) so both read a date the same way.

import { getTodaySchedule } from "./schoolSchedule";
import { getTodaySpecial } from "./kimberlySchedule";

function getDayInfo(person, dateStr) {
  if (person === "Adam") {
    const s = getTodaySchedule(dateStr);
    if (!s.isSchoolDay) return { label: "No school", sub: null };
    return { label: `Day ${s.letterDay}`, sub: s.scheduleType !== "regular" ? s.scheduleLabel : null };
  }
  const s = getTodaySpecial(dateStr);
  if (!s.isSchoolDay) return { label: "No school", sub: null };
  return { label: s.special ? s.special.name : "—", sub: s.halfDay ? "Half Day" : null };
}

export { getDayInfo };
